import { Search } from "lucide-react"
import { Input } from "@/components/ui/input"

interface BillSearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export function BillSearchInput({
  value,
  onChange,
  placeholder = "Search bill number..."
}: BillSearchInputProps) {
  return (
    <div className="relative">
      <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-8 w-full"
        aria-label="Search By Bill Number"
      />
    </div>
  )
}